// extracted by mini-css-extract-plugin
export var standaloneTable = "_1x-0";
export var standaloneTableWithBodyFill = "_1x-1";
export var withExtraHeader = "_1x-2";